// extracted by mini-css-extract-plugin
export var copyableField = "_mc-4";
export var customerBadge = "_mc-0";
export var customerInfoTitle = "_mc-2";
export var details = "_mc-1";
export var dropdownContainer = "_mc-5";
export var dropdownImage = "_mc-6";
export var editAssigneeForm = "_mc-a";
export var editButton = "_mc-3";
export var email = "_mc-7";
export var hidden = "_mc-d";
export var input = "_mc-8";
export var saveButton = "_mc-b";
export var shopifyIcon = "_mc-c";
export var suggestionBadge = "_mc-e";
export var suggestionText = "_mc-f";
export var username = "_mc-9";